module.exports = [{"data":"bno","title":"Bunch Number"},{"data":"bwt","title":"Bunch Weight"},{"data":"roundno","title":"Round Number"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/yield-raw-variable.json
// module id = T3qI
// module chunks = 102